import { render, staticRenderFns } from "./ViewCustomerSegment.vue?vue&type=template&id=7fff63ac&"
import script from "./ViewCustomerSegment.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fff63ac')) {
      api.createRecord('7fff63ac', component.options)
    } else {
      api.reload('7fff63ac', component.options)
    }
    module.hot.accept("./ViewCustomerSegment.vue?vue&type=template&id=7fff63ac&", function () {
      api.rerender('7fff63ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/ViewCustomerSegment.vue"
export default component.exports